import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import "../styles/sections/Footer.css"


export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col lg={12}>
            <div className="newsletter-bx wow slideInUp">
              <Row>
                <h4>Thank you for exploring my work. I’m always open to feedback, collaboration, and supporting students or new grads who are getting started.</h4>
                <h3>Let’s build a better future—one project at a time.</h3>
              </Row>
            </div>
          </Col>
          <Col size={12} sm={6}>
            <img style={{ width: '20vw' }} src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/arash-esf/" target="_blank" rel="noreferrer"><img src={navIcon1} alt="LinkedIn Icon" /></a>
              {/* <a href="#"><img src={navIcon2} alt="Icon" /></a>
              <a href="#"><img src={navIcon3} alt="Icon" /></a> */}
            </div>
            <p>Last updated: Feb 2026</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
